import { IAxiosService } from "../interfaces/IAxiosService";
import { Config } from "../models/Config";
import axios from 'axios';

import { SampleWebhookPayload } from '../models/SampleWebhookPayload'

export class AxiosService implements IAxiosService {
    private readonly config : Config = require("../../config.json");
    private readonly apiUrl : string = this.config.apiUrl;
    private axios = axios;

    constructor(isAdmin: boolean = false, adminCookie: string = "") {
        if (isAdmin) {
            this.axios.defaults.headers.common["metis-passport"] = adminCookie;
        }
    }

    //Get
    async GetScopedDefinitions() {
        return this.getMany('/api/auth/scopedefinitions');
    }
    async GetIntegrationTestsLibrary(library : string) {
        return this.getOne(`/api/dashboard/admin/integrationtests/libraries?libraryName=${library}`);
    }
    async GetIntegrationTests() {
        return this.getMany('/api/dashboard/admin/integrationtests/all');
    }
    async GetIntegrationTestsWebhooks() {
        return this.getMany('/api/dashboard/admin/integrationtests/webhooks');
    }
    async GetSearchableTypes() {
        return this.getMany('/api/docs/search');
    }
    async GetAdminProcs() {
        return this.getMany('/api/dashboard/admin/processes/procs');
    }
    
    //Post
    async VerifyAdmin() {
        return this.post(`/api/auth/validate/admin`);
    }
    async OktaLogin(loginRequest : any) {
        return this.post(`/api/auth/login/okta`, loginRequest);
    }
    async AdminOktaLogin(accessToken : any) {
        return this.post(`/api/auth/login/admin/okta`, accessToken);
    }
    async Login(loginRequest : any) {
        return this.post('/api/auth/login', loginRequest);
    }
    async Logout() {
        return this.post('/api/auth/logout');
    }
    async PostIntegrationTestsPlan(plan : any) {
        return this.post('/api/dashboard/admin/integrationtests', plan);
    }
    async PostSampleWebhookPayload(payload : SampleWebhookPayload) {
        return this.postToCustomUrl(payload.url, payload);
    }
    async RunAdminProc(proc : any) {
        return this.post('/api/dashboard/admin/processes/procs', proc);
    }

    //Delete
    async DeleteIntegrationTests() {
        return this.delete('/api/dashboard/admin/integrationtests/all');
    }

    async getOne(edge : string, id: string = "") {
        return this.axios
            .get(`${this.apiUrl}${edge}${id}`)
            .then(response => {
                return response.data.data
            })
            .catch(error => {
                var message = this.GetErrorMessages(error);
                throw new Error(message);
            });
    }

    async post<T extends Object>(edge : string, value?: T): Promise<string> {
        return this.axios
            .post(`${this.apiUrl}${edge}`, value)
            .then(response => { 
                return response.data.data;
            })
            .catch(error => {
                var message = this.GetErrorMessages(error);
                throw new Error(message);
            });
    }

    async postToCustomUrl<T extends Object>(customUrl : string, value?: T): Promise<string> {
        const returnItem = this.axios
            .post(customUrl, value)
            .then(response => { 
                return response.data.data;
            })
            .catch(error => {
                var message = this.GetErrorMessages(error);
                throw new Error(message);
            });
        return returnItem;
    }

    private getMany(edge : string) {
        return this.axios
            .get(`${this.apiUrl}${edge}`)
            .then(response => {
                return response.data.data;
            })
            .catch((error : any) => {
                var message = this.GetErrorMessages(error);
                throw new Error(message);
            });
    }

    async delete(edge : string, id: string = ""): Promise<boolean> {
        return await this.axios
            .delete(`${this.apiUrl}${edge}${id}`)
            .then(() => {
                return true;
            })
            .catch((error : any) => {
                var message = this.GetErrorMessages(error);
                throw new Error(message);
            });
    }

    GetErrorMessages(error : any) : string {
        var message: string = "";
        if (error?.response?.data?.errors) {
            error.response.data.errors.forEach((error: any) => {
                message += error.message + "\r\n";
            });
        }
        else if (error?.response?.statusText) {
            message += error?.response?.statusText;
        }
        return message;
    }
}